import { render, staticRenderFns } from "./CreateBatchModal.vue?vue&type=template&id=0118a574&scoped=true&"
import script from "./CreateBatchModal.vue?vue&type=script&lang=ts&"
export * from "./CreateBatchModal.vue?vue&type=script&lang=ts&"
import style0 from "./CreateBatchModal.vue?vue&type=style&index=0&id=0118a574&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0118a574",
  null
  
)

export default component.exports